import React from 'react';
import { observer } from 'mobx-react';
import { useClientStore } from 'apps/hooks';
import { Box, Button, IconButton, Tooltip } from 'components';
import { Delete /* Edit, Download, Share */ } from 'icons';

import type QuotePageAppManager from 'apps/shipmentQuote/QuotePage/appManager';
import { ShipmentQuoteNavigate } from 'apps/shipmentQuote/utils';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

const alignCenterStyle = {
  display: 'flex',
  alignItems: 'center',
};

interface ActionButtonsProps {
  quoteAppManager: QuotePageAppManager;
  loading: boolean;
  disabled: boolean;
}

const copyQuote = 'Copy quote';
const deleteQuote = 'Delete quote';

export const HeaderActions = observer(function HeaderActions({
  quoteAppManager,
  loading,
  disabled = false,
}: ActionButtonsProps) {
  const clientStore = useClientStore();
  const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';

  const { quote } = quoteAppManager;

  const handleDeleteQuote = () => {
    modalStore.SetModalComponent(ConfirmAction, {
      callBack: () => {
        quoteAppManager.DeleteShipmentQuote();
      },
      title: 'Are you sure you want to delete this Shipment Quote?',
      undo: true,
    });
  };

  const handlePay = () => {
    quoteAppManager.PayQuote();
  };

  const handleClone = () => {
    const slug = quote.customerSpace.path;
    const productQuoteIds = quote.productQuotes.map(pq => pq.dgraphId);

    ShipmentQuoteNavigate(clientStore.routerStore, {
      customerSlug: slug,
      pqids: productQuoteIds,
      mode: 'clone',
      cloneId: quote.id,
    });
  };

  const areThereOrdersAttached = quoteAppManager.quote.orders.length > 0;

  if (isIntermediator) {
    return (
      <Box sx={alignCenterStyle}>
        <Tooltip id={deleteQuote} place='bottom' delayShow={1000} />
        <IconButton
          variant='outlined'
          icon={<Delete />}
          data-tip={deleteQuote}
          data-for={deleteQuote}
          onClick={handleDeleteQuote}
          disabled={areThereOrdersAttached}
        />

        <Tooltip id={copyQuote} place='bottom' delayShow={1000} />
        <Button
          margin='16px 0 16px 16px'
          data-testid='quote-clone-button'
          size='small'
          onClick={handleClone}
          icon='copy'
          outline
          data-tip={copyQuote}
          data-for={copyQuote}
        />
        {/* <Button
        text='Requote'
        size='small'
        icon='arrow_right'
        iconPosition='right'
        onClick={handleRequote}
      /> */}
      </Box>
    );
  }

  return (
    <Box sx={alignCenterStyle}>
      {/* <IconButton variant='outlined' icon={<Download />} mr={4} />
      <IconButton variant='outlined' icon={<Share />} mr={4} /> */}
      <Button
        text='Pay now'
        size='small'
        outline
        loading={loading}
        icon='arrow_right'
        iconPosition='right'
        onClick={handlePay}
        disabled={disabled}
      />
    </Box>
  );
});
